import { render, staticRenderFns } from "./ClinicNurseDashboard.vue?vue&type=template&id=2756cae0&"
import script from "./ClinicNurseDashboard.vue?vue&type=script&lang=js&"
export * from "./ClinicNurseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClinicNurseDashboard.vue?vue&type=style&index=0&id=2756cae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports